import * as React from 'react';
import {useSelector} from 'react-redux';
import parseISO from 'date-fns/parseISO';

import {useReleaseFlag} from './product-flags';
import type {RerouterLocation} from 'src/rerouter';
import {useLocation} from 'src/rerouter/hooks';
import {selectCurrentAccount} from 'src/selectors/accounts';
import {selectAgencyData} from 'src/selectors/agency';

/* this is a snippet we got from delighted and we didn't write this js,
but we turned it into a hook so that we could
call it safely without modifying the whole site"*/

export function useDelighted(): boolean {
  const [isAvailable, setIsAvailable] = React.useState(false);

  React.useEffect(() => {
    /* eslint-disable */
    // @ts-expect-error - TS1345 - An expression of type 'void' cannot be tested for truthiness.
    !(function (e, t, r, n) {
      // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
      if (!e[n]) {
        for (
          // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
          var a = (e[n] = []),
            i = [
              'survey',
              'reset',
              'config',
              'init',
              'set',
              'get',
              'event',
              'identify',
              'track',
              'page',
              'screen',
              'group',
              'alias',
            ],
            s = 0;
          s < i.length;
          s++
        ) {
          var c = i[s];
          // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
          a[c] =
            // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
            a[c] ||
            (function (e) {
              return function () {
                var t = Array.prototype.slice.call(arguments);
                // @ts-expect-error - TS2345 - Argument of type '(string | any[])[]' is not assignable to parameter of type 'never'.
                a.push([e, t]);
              };
            })(c);
        }
        // @ts-expect-error - TS2339 - Property 'SNIPPET_VERSION' does not exist on type 'never[]'.
        a.SNIPPET_VERSION = '1.0.1';
        var o = t.createElement('script');
        (o.type = 'text/javascript'),
          (o.async = !0),
          (o.src =
            'https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/' +
            r +
            '/' +
            n +
            '.js');
        var p = t.getElementsByTagName('script')[0];
        // @ts-expect-error - TS18047 - 'p.parentNode' is possibly 'null'.
        p.parentNode.insertBefore(o, p);

        setIsAvailable(true);
      }
    })(window, document, 'RmMUCP2xTidD1ZY2', 'delighted');
  }, []);

  return isAvailable;
}

export function useDelightedRouteSurvey(routeProjectMapping: {
  [route: string]: string;
}) {
  const isDelightedAvailable = useDelighted();
  const location = useLocation();
  const delightedEnabled = useReleaseFlag('delightedEnabled');

  const currentAccount = useSelector(selectCurrentAccount);
  const agency = useSelector(selectAgencyData);

  const projectForRoute: string | null | undefined = ((
    location: RerouterLocation,
  ) => {
    const pathname = location.pathname.replace(/\/[+?]\d+/, '/:id');
    if (pathname in routeProjectMapping) {
      return routeProjectMapping[pathname];
    }
    return null;
  })(location);

  React.useEffect(() => {
    if (currentAccount) {
      const {name, email, timeCreated, salesforceContactId} = currentAccount;
      if (
        isDelightedAvailable &&
        delightedEnabled &&
        timeCreated &&
        salesforceContactId &&
        projectForRoute
      ) {
        // @ts-expect-error - TS2339 - Property 'delighted' does not exist on type 'Window & typeof globalThis'.
        window.delighted.survey({
          name,
          email,
          properties: {
            salesforce_contact_id: salesforceContactId,
            projectName: projectForRoute,
            agencyName: agency.name,
          },
          createdAt: parseISO(timeCreated).toISOString(),
        });
      }
    }
  }, [isDelightedAvailable, delightedEnabled, projectForRoute]);
}
